export default __webpack_public_path__ + "static/media/PrgmH2.cb404b89.png";